"use strict";
// Please keep alphabetized
var IconName;
(function (IconName) {
    IconName[IconName["AADLogo"] = 0] = "AADLogo";
    IconName[IconName["Accept"] = 1] = "Accept";
    IconName[IconName["AccessLogo"] = 2] = "AccessLogo";
    IconName[IconName["Accounts"] = 3] = "Accounts";
    IconName[IconName["Add"] = 4] = "Add";
    IconName[IconName["AddEvent"] = 5] = "AddEvent";
    IconName[IconName["AddFavorite"] = 6] = "AddFavorite";
    IconName[IconName["AddFavoriteFill"] = 7] = "AddFavoriteFill";
    IconName[IconName["AddFriend"] = 8] = "AddFriend";
    IconName[IconName["AddGroup"] = 9] = "AddGroup";
    IconName[IconName["AddOnlineMeeting"] = 10] = "AddOnlineMeeting";
    IconName[IconName["AddPhone"] = 11] = "AddPhone";
    IconName[IconName["AddTo"] = 12] = "AddTo";
    IconName[IconName["Admin"] = 13] = "Admin";
    IconName[IconName["AdminALogo"] = 14] = "AdminALogo";
    IconName[IconName["AdminCLogo"] = 15] = "AdminCLogo";
    IconName[IconName["AdminDLogo"] = 16] = "AdminDLogo";
    IconName[IconName["AdminELogo"] = 17] = "AdminELogo";
    IconName[IconName["AdminLLogo"] = 18] = "AdminLLogo";
    IconName[IconName["AdminMLogo"] = 19] = "AdminMLogo";
    IconName[IconName["AdminOLogo"] = 20] = "AdminOLogo";
    IconName[IconName["AdminPLogo"] = 21] = "AdminPLogo";
    IconName[IconName["AdminSLogo"] = 22] = "AdminSLogo";
    IconName[IconName["AdminYLogo"] = 23] = "AdminYLogo";
    IconName[IconName["Airplane"] = 24] = "Airplane";
    IconName[IconName["AirTickets"] = 25] = "AirTickets";
    IconName[IconName["AlarmClock"] = 26] = "AlarmClock";
    IconName[IconName["Album"] = 27] = "Album";
    IconName[IconName["AlbumRemove"] = 28] = "AlbumRemove";
    IconName[IconName["AlchemyLogo"] = 29] = "AlchemyLogo";
    IconName[IconName["AlignCenter"] = 30] = "AlignCenter";
    IconName[IconName["AlignLeft"] = 31] = "AlignLeft";
    IconName[IconName["AlignRight"] = 32] = "AlignRight";
    IconName[IconName["AndroidLogo"] = 33] = "AndroidLogo";
    IconName[IconName["Annotation"] = 34] = "Annotation";
    IconName[IconName["AppForOfficeLogo"] = 35] = "AppForOfficeLogo";
    IconName[IconName["AppIconDefault"] = 36] = "AppIconDefault";
    IconName[IconName["Arrivals"] = 37] = "Arrivals";
    IconName[IconName["ArrowDownRight8"] = 38] = "ArrowDownRight8";
    IconName[IconName["ArrowDownRightMirrored8"] = 39] = "ArrowDownRightMirrored8";
    IconName[IconName["ArrowUpRight8"] = 40] = "ArrowUpRight8";
    IconName[IconName["ArrowUpRightMirrored8"] = 41] = "ArrowUpRightMirrored8";
    IconName[IconName["Articles"] = 42] = "Articles";
    IconName[IconName["Ascending"] = 43] = "Ascending";
    IconName[IconName["AssetLibrary"] = 44] = "AssetLibrary";
    IconName[IconName["Asterisk"] = 45] = "Asterisk";
    IconName[IconName["ATPLogo"] = 46] = "ATPLogo";
    IconName[IconName["Attach"] = 47] = "Attach";
    IconName[IconName["AustralianRules"] = 48] = "AustralianRules";
    IconName[IconName["AutoEnhanceOff"] = 49] = "AutoEnhanceOff";
    IconName[IconName["AutoEnhanceOn"] = 50] = "AutoEnhanceOn";
    IconName[IconName["AutoRacing"] = 51] = "AutoRacing";
    IconName[IconName["AwayStatus"] = 52] = "AwayStatus";
    IconName[IconName["AzureLogo"] = 53] = "AzureLogo";
    IconName[IconName["Back"] = 54] = "Back";
    IconName[IconName["BackToWindow"] = 55] = "BackToWindow";
    IconName[IconName["Badge"] = 56] = "Badge";
    IconName[IconName["Balloons"] = 57] = "Balloons";
    IconName[IconName["BarChart4"] = 58] = "BarChart4";
    IconName[IconName["BarChartHorizontal"] = 59] = "BarChartHorizontal";
    IconName[IconName["Baseball"] = 60] = "Baseball";
    IconName[IconName["BidiLtr"] = 61] = "BidiLtr";
    IconName[IconName["BidiRtl"] = 62] = "BidiRtl";
    IconName[IconName["BingLogo"] = 63] = "BingLogo";
    IconName[IconName["BlockContact"] = 64] = "BlockContact";
    IconName[IconName["Blocked"] = 65] = "Blocked";
    IconName[IconName["Blocked2"] = 66] = "Blocked2";
    IconName[IconName["BlowingSnow"] = 67] = "BlowingSnow";
    IconName[IconName["Boards"] = 68] = "Boards";
    IconName[IconName["Bold"] = 69] = "Bold";
    IconName[IconName["BookingsLogo"] = 70] = "BookingsLogo";
    IconName[IconName["Bookmarks"] = 71] = "Bookmarks";
    IconName[IconName["BookmarksMirrored"] = 72] = "BookmarksMirrored";
    IconName[IconName["BoxLogo"] = 73] = "BoxLogo";
    IconName[IconName["BranchFork"] = 74] = "BranchFork";
    IconName[IconName["Breadcrumb"] = 75] = "Breadcrumb";
    IconName[IconName["Brightness"] = 76] = "Brightness";
    IconName[IconName["Broom"] = 77] = "Broom";
    IconName[IconName["BufferTimeAfter"] = 78] = "BufferTimeAfter";
    IconName[IconName["BufferTimeBefore"] = 79] = "BufferTimeBefore";
    IconName[IconName["BufferTimeBoth"] = 80] = "BufferTimeBoth";
    IconName[IconName["BulletedList"] = 81] = "BulletedList";
    IconName[IconName["BulletedListMirrored"] = 82] = "BulletedListMirrored";
    IconName[IconName["BusSolid"] = 83] = "BusSolid";
    IconName[IconName["Cafe"] = 84] = "Cafe";
    IconName[IconName["Cake"] = 85] = "Cake";
    IconName[IconName["CalculatorAddition"] = 86] = "CalculatorAddition";
    IconName[IconName["CalculatorSubtract"] = 87] = "CalculatorSubtract";
    IconName[IconName["Calendar"] = 88] = "Calendar";
    IconName[IconName["CalendarAgenda"] = 89] = "CalendarAgenda";
    IconName[IconName["CalendarDay"] = 90] = "CalendarDay";
    IconName[IconName["CalendarMirrored"] = 91] = "CalendarMirrored";
    IconName[IconName["CalendarReply"] = 92] = "CalendarReply";
    IconName[IconName["CalendarWeek"] = 93] = "CalendarWeek";
    IconName[IconName["CalendarWorkWeek"] = 94] = "CalendarWorkWeek";
    IconName[IconName["CaloriesAdd"] = 95] = "CaloriesAdd";
    IconName[IconName["Camera"] = 96] = "Camera";
    IconName[IconName["Cancel"] = 97] = "Cancel";
    IconName[IconName["Car"] = 98] = "Car";
    IconName[IconName["CaretBottomLeftSolid8"] = 99] = "CaretBottomLeftSolid8";
    IconName[IconName["CaretBottomRightSolid8"] = 100] = "CaretBottomRightSolid8";
    IconName[IconName["CaretDown8"] = 101] = "CaretDown8";
    IconName[IconName["CaretDownSolid8"] = 102] = "CaretDownSolid8";
    IconName[IconName["CaretHollow"] = 103] = "CaretHollow";
    IconName[IconName["CaretHollowMirrored"] = 104] = "CaretHollowMirrored";
    IconName[IconName["CaretLeft8"] = 105] = "CaretLeft8";
    IconName[IconName["CaretLeftSolid8"] = 106] = "CaretLeftSolid8";
    IconName[IconName["CaretRight8"] = 107] = "CaretRight8";
    IconName[IconName["CaretRightSolid8"] = 108] = "CaretRightSolid8";
    IconName[IconName["CaretSolid"] = 109] = "CaretSolid";
    IconName[IconName["CaretSolidMirrored"] = 110] = "CaretSolidMirrored";
    IconName[IconName["CaretTopLeftSolid8"] = 111] = "CaretTopLeftSolid8";
    IconName[IconName["CaretTopRightSolid8"] = 112] = "CaretTopRightSolid8";
    IconName[IconName["CaretUp8"] = 113] = "CaretUp8";
    IconName[IconName["CaretUpSolid8"] = 114] = "CaretUpSolid8";
    IconName[IconName["Cat"] = 115] = "Cat";
    IconName[IconName["CellPhone"] = 116] = "CellPhone";
    IconName[IconName["Certificate"] = 117] = "Certificate";
    IconName[IconName["Chart"] = 118] = "Chart";
    IconName[IconName["Chat"] = 119] = "Chat";
    IconName[IconName["ChatInviteFriend"] = 120] = "ChatInviteFriend";
    IconName[IconName["Checkbox"] = 121] = "Checkbox";
    IconName[IconName["CheckboxComposite"] = 122] = "CheckboxComposite";
    IconName[IconName["CheckboxIndeterminate"] = 123] = "CheckboxIndeterminate";
    IconName[IconName["CheckList"] = 124] = "CheckList";
    IconName[IconName["CheckMark"] = 125] = "CheckMark";
    IconName[IconName["ChevronDown"] = 126] = "ChevronDown";
    IconName[IconName["ChevronDownMed"] = 127] = "ChevronDownMed";
    IconName[IconName["ChevronDownSmall"] = 128] = "ChevronDownSmall";
    IconName[IconName["ChevronLeft"] = 129] = "ChevronLeft";
    IconName[IconName["ChevronLeftMed"] = 130] = "ChevronLeftMed";
    IconName[IconName["ChevronLeftSmall"] = 131] = "ChevronLeftSmall";
    IconName[IconName["ChevronRight"] = 132] = "ChevronRight";
    IconName[IconName["ChevronRightMed"] = 133] = "ChevronRightMed";
    IconName[IconName["ChevronRightSmall"] = 134] = "ChevronRightSmall";
    IconName[IconName["ChevronUp"] = 135] = "ChevronUp";
    IconName[IconName["ChevronUpMed"] = 136] = "ChevronUpMed";
    IconName[IconName["ChevronUpSmall"] = 137] = "ChevronUpSmall";
    IconName[IconName["ChromeBack"] = 138] = "ChromeBack";
    IconName[IconName["ChromeBackMirrored"] = 139] = "ChromeBackMirrored";
    IconName[IconName["ChromeClose"] = 140] = "ChromeClose";
    IconName[IconName["ChromeMinimize"] = 141] = "ChromeMinimize";
    IconName[IconName["CircleFill"] = 142] = "CircleFill";
    IconName[IconName["CircleHalfFull"] = 143] = "CircleHalfFull";
    IconName[IconName["CirclePlus"] = 144] = "CirclePlus";
    IconName[IconName["CircleRing"] = 145] = "CircleRing";
    IconName[IconName["ClassNotebookLogo"] = 146] = "ClassNotebookLogo";
    IconName[IconName["ClassroomLogo"] = 147] = "ClassroomLogo";
    IconName[IconName["Clear"] = 148] = "Clear";
    IconName[IconName["ClearFilter"] = 149] = "ClearFilter";
    IconName[IconName["ClearFormatting"] = 150] = "ClearFormatting";
    IconName[IconName["ClearNight"] = 151] = "ClearNight";
    IconName[IconName["Clock"] = 152] = "Clock";
    IconName[IconName["ClosedCaption"] = 153] = "ClosedCaption";
    IconName[IconName["ClosePane"] = 154] = "ClosePane";
    IconName[IconName["ClosePaneMirrored"] = 155] = "ClosePaneMirrored";
    IconName[IconName["CloudAdd"] = 156] = "CloudAdd";
    IconName[IconName["CloudDownload"] = 157] = "CloudDownload";
    IconName[IconName["CloudUpload"] = 158] = "CloudUpload";
    IconName[IconName["CloudWeather"] = 159] = "CloudWeather";
    IconName[IconName["Cloudy"] = 160] = "Cloudy";
    IconName[IconName["Cocktails"] = 161] = "Cocktails";
    IconName[IconName["Code"] = 162] = "Code";
    IconName[IconName["Coffee"] = 163] = "Coffee";
    IconName[IconName["CollabsDBLogo"] = 164] = "CollabsDBLogo";
    IconName[IconName["CollapseMenu"] = 165] = "CollapseMenu";
    IconName[IconName["CollegeFootball"] = 166] = "CollegeFootball";
    IconName[IconName["CollegeHoops"] = 167] = "CollegeHoops";
    IconName[IconName["Color"] = 168] = "Color";
    IconName[IconName["Combine"] = 169] = "Combine";
    IconName[IconName["CompassNW"] = 170] = "CompassNW";
    IconName[IconName["Completed"] = 171] = "Completed";
    IconName[IconName["CompletedSolid"] = 172] = "CompletedSolid";
    IconName[IconName["Contact"] = 173] = "Contact";
    IconName[IconName["ContactCard"] = 174] = "ContactCard";
    IconName[IconName["ContactInfo"] = 175] = "ContactInfo";
    IconName[IconName["Contrast"] = 176] = "Contrast";
    IconName[IconName["Copy"] = 177] = "Copy";
    IconName[IconName["Cotton"] = 178] = "Cotton";
    IconName[IconName["Cricket"] = 179] = "Cricket";
    IconName[IconName["CSS"] = 180] = "CSS";
    IconName[IconName["CustomIcon"] = 181] = "CustomIcon";
    IconName[IconName["CustomList"] = 182] = "CustomList";
    IconName[IconName["CustomListMirrored"] = 183] = "CustomListMirrored";
    IconName[IconName["Cycling"] = 184] = "Cycling";
    IconName[IconName["DataConnectionLibrary"] = 185] = "DataConnectionLibrary";
    IconName[IconName["DateTime"] = 186] = "DateTime";
    IconName[IconName["DateTime2"] = 187] = "DateTime2";
    IconName[IconName["DateTimeMirrored"] = 188] = "DateTimeMirrored";
    IconName[IconName["DecreaseIndentLegacy"] = 189] = "DecreaseIndentLegacy";
    IconName[IconName["Delete"] = 190] = "Delete";
    IconName[IconName["DelveAnalytics"] = 191] = "DelveAnalytics";
    IconName[IconName["DelveAnalyticsLogo"] = 192] = "DelveAnalyticsLogo";
    IconName[IconName["DelveLogo"] = 193] = "DelveLogo";
    IconName[IconName["Descending"] = 194] = "Descending";
    IconName[IconName["Design"] = 195] = "Design";
    IconName[IconName["DeveloperTools"] = 196] = "DeveloperTools";
    IconName[IconName["Devices3"] = 197] = "Devices3";
    IconName[IconName["Devices4"] = 198] = "Devices4";
    IconName[IconName["Dialpad"] = 199] = "Dialpad";
    IconName[IconName["Dictionary"] = 200] = "Dictionary";
    IconName[IconName["DietPlanNotebook"] = 201] = "DietPlanNotebook";
    IconName[IconName["DisableUpdates"] = 202] = "DisableUpdates";
    IconName[IconName["Dislike"] = 203] = "Dislike";
    IconName[IconName["DockLeft"] = 204] = "DockLeft";
    IconName[IconName["DockLeftMirrored"] = 205] = "DockLeftMirrored";
    IconName[IconName["DockRight"] = 206] = "DockRight";
    IconName[IconName["DocLibrary"] = 207] = "DocLibrary";
    IconName[IconName["DocsLogo"] = 208] = "DocsLogo";
    IconName[IconName["Document"] = 209] = "Document";
    IconName[IconName["Documentation"] = 210] = "Documentation";
    IconName[IconName["DocumentReply"] = 211] = "DocumentReply";
    IconName[IconName["DocumentSearch"] = 212] = "DocumentSearch";
    IconName[IconName["DocumentSet"] = 213] = "DocumentSet";
    IconName[IconName["Door"] = 214] = "Door";
    IconName[IconName["DoubleBookmark"] = 215] = "DoubleBookmark";
    IconName[IconName["DoubleChevronDown"] = 216] = "DoubleChevronDown";
    IconName[IconName["DoubleChevronDown12"] = 217] = "DoubleChevronDown12";
    IconName[IconName["DoubleChevronLeft"] = 218] = "DoubleChevronLeft";
    IconName[IconName["DoubleChevronLeft12"] = 219] = "DoubleChevronLeft12";
    IconName[IconName["DoubleChevronLeftMed"] = 220] = "DoubleChevronLeftMed";
    IconName[IconName["DoubleChevronLeftMedMirrored"] = 221] = "DoubleChevronLeftMedMirrored";
    IconName[IconName["DoubleChevronRight"] = 222] = "DoubleChevronRight";
    IconName[IconName["DoubleChevronRight12"] = 223] = "DoubleChevronRight12";
    IconName[IconName["DoubleChevronUp"] = 224] = "DoubleChevronUp";
    IconName[IconName["DoubleChevronUp12"] = 225] = "DoubleChevronUp12";
    IconName[IconName["Down"] = 226] = "Down";
    IconName[IconName["Download"] = 227] = "Download";
    IconName[IconName["DRM"] = 228] = "DRM";
    IconName[IconName["Drop"] = 229] = "Drop";
    IconName[IconName["DropboxLogo"] = 230] = "DropboxLogo";
    IconName[IconName["Dropdown"] = 231] = "Dropdown";
    IconName[IconName["Duststorm"] = 232] = "Duststorm";
    IconName[IconName["Dynamics365Logo"] = 233] = "Dynamics365Logo";
    IconName[IconName["DynamicSMBLogo"] = 234] = "DynamicSMBLogo";
    IconName[IconName["EatDrink"] = 235] = "EatDrink";
    IconName[IconName["EdgeLogo"] = 236] = "EdgeLogo";
    IconName[IconName["Edit"] = 237] = "Edit";
    IconName[IconName["EditMail"] = 238] = "EditMail";
    IconName[IconName["EditMirrored"] = 239] = "EditMirrored";
    IconName[IconName["EditNote"] = 240] = "EditNote";
    IconName[IconName["EditPhoto"] = 241] = "EditPhoto";
    IconName[IconName["EditStyle"] = 242] = "EditStyle";
    IconName[IconName["Embed"] = 243] = "Embed";
    IconName[IconName["EMI"] = 244] = "EMI";
    IconName[IconName["Emoji"] = 245] = "Emoji";
    IconName[IconName["Emoji2"] = 246] = "Emoji2";
    IconName[IconName["EmojiDisappointed"] = 247] = "EmojiDisappointed";
    IconName[IconName["EmojiNeutral"] = 248] = "EmojiNeutral";
    IconName[IconName["EmptyRecycleBin"] = 249] = "EmptyRecycleBin";
    IconName[IconName["Equalizer"] = 250] = "Equalizer";
    IconName[IconName["EraseTool"] = 251] = "EraseTool";
    IconName[IconName["Error"] = 252] = "Error";
    IconName[IconName["ErrorBadge"] = 253] = "ErrorBadge";
    IconName[IconName["Event"] = 254] = "Event";
    IconName[IconName["EventInfo"] = 255] = "EventInfo";
    IconName[IconName["ExcelDocument"] = 256] = "ExcelDocument";
    IconName[IconName["ExcelLogo"] = 257] = "ExcelLogo";
    IconName[IconName["ExchangeLogo"] = 258] = "ExchangeLogo";
    IconName[IconName["ExpandMenu"] = 259] = "ExpandMenu";
    IconName[IconName["FabricAssetLibrary"] = 260] = "FabricAssetLibrary";
    IconName[IconName["FabricDataConnectionLibrary"] = 261] = "FabricDataConnectionLibrary";
    IconName[IconName["FabricDocLibrary"] = 262] = "FabricDocLibrary";
    IconName[IconName["FabricFolder"] = 263] = "FabricFolder";
    IconName[IconName["FabricFolderFill"] = 264] = "FabricFolderFill";
    IconName[IconName["FabricFolderSearch"] = 265] = "FabricFolderSearch";
    IconName[IconName["FabricFormLibrary"] = 266] = "FabricFormLibrary";
    IconName[IconName["FabricFormLibraryMirrored"] = 267] = "FabricFormLibraryMirrored";
    IconName[IconName["FabricMovetoFolder"] = 268] = "FabricMovetoFolder";
    IconName[IconName["FabricNewFolder"] = 269] = "FabricNewFolder";
    IconName[IconName["FabricOpenFolderHorizontal"] = 270] = "FabricOpenFolderHorizontal";
    IconName[IconName["FabricPictureLibrary"] = 271] = "FabricPictureLibrary";
    IconName[IconName["FabricPublicFolder"] = 272] = "FabricPublicFolder";
    IconName[IconName["FabricReportLibrary"] = 273] = "FabricReportLibrary";
    IconName[IconName["FabricReportLibraryMirrored"] = 274] = "FabricReportLibraryMirrored";
    IconName[IconName["FabricSyncFolder"] = 275] = "FabricSyncFolder";
    IconName[IconName["FabricUnsyncFolder"] = 276] = "FabricUnsyncFolder";
    IconName[IconName["FacebookLogo"] = 277] = "FacebookLogo";
    IconName[IconName["Family"] = 278] = "Family";
    IconName[IconName["FangBody"] = 279] = "FangBody";
    IconName[IconName["FavoriteList"] = 280] = "FavoriteList";
    IconName[IconName["FavoriteStar"] = 281] = "FavoriteStar";
    IconName[IconName["FavoriteStarFill"] = 282] = "FavoriteStarFill";
    IconName[IconName["Fax"] = 283] = "Fax";
    IconName[IconName["Ferry"] = 284] = "Ferry";
    IconName[IconName["FerrySolid"] = 285] = "FerrySolid";
    IconName[IconName["Filter"] = 286] = "Filter";
    IconName[IconName["Filters"] = 287] = "Filters";
    IconName[IconName["Financial"] = 288] = "Financial";
    IconName[IconName["Fingerprint"] = 289] = "Fingerprint";
    IconName[IconName["Flag"] = 290] = "Flag";
    IconName[IconName["FlickDown"] = 291] = "FlickDown";
    IconName[IconName["FlickLeft"] = 292] = "FlickLeft";
    IconName[IconName["FlickRight"] = 293] = "FlickRight";
    IconName[IconName["FlickUp"] = 294] = "FlickUp";
    IconName[IconName["Flow"] = 295] = "Flow";
    IconName[IconName["Fog"] = 296] = "Fog";
    IconName[IconName["Folder"] = 297] = "Folder";
    IconName[IconName["FolderFill"] = 298] = "FolderFill";
    IconName[IconName["FolderHorizontal"] = 299] = "FolderHorizontal";
    IconName[IconName["FolderOpen"] = 300] = "FolderOpen";
    IconName[IconName["FolderSearch"] = 301] = "FolderSearch";
    IconName[IconName["Font"] = 302] = "Font";
    IconName[IconName["FontColor"] = 303] = "FontColor";
    IconName[IconName["FontDecrease"] = 304] = "FontDecrease";
    IconName[IconName["FontIncrease"] = 305] = "FontIncrease";
    IconName[IconName["FontSize"] = 306] = "FontSize";
    IconName[IconName["FormLibrary"] = 307] = "FormLibrary";
    IconName[IconName["FormLibraryMirrored"] = 308] = "FormLibraryMirrored";
    IconName[IconName["Forward"] = 309] = "Forward";
    IconName[IconName["ForwardEvent"] = 310] = "ForwardEvent";
    IconName[IconName["Freezing"] = 311] = "Freezing";
    IconName[IconName["Frigid"] = 312] = "Frigid";
    IconName[IconName["FullCircleMask"] = 313] = "FullCircleMask";
    IconName[IconName["FullScreen"] = 314] = "FullScreen";
    IconName[IconName["Generate"] = 315] = "Generate";
    IconName[IconName["Giftbox"] = 316] = "Giftbox";
    IconName[IconName["GiftCard"] = 317] = "GiftCard";
    IconName[IconName["Glasses"] = 318] = "Glasses";
    IconName[IconName["Glimmer"] = 319] = "Glimmer";
    IconName[IconName["GlobalNavButton"] = 320] = "GlobalNavButton";
    IconName[IconName["Globe"] = 321] = "Globe";
    IconName[IconName["GlobeFavorite"] = 322] = "GlobeFavorite";
    IconName[IconName["Golf"] = 323] = "Golf";
    IconName[IconName["GoogleDriveLogo"] = 324] = "GoogleDriveLogo";
    IconName[IconName["GotoToday"] = 325] = "GotoToday";
    IconName[IconName["GripperTool"] = 326] = "GripperTool";
    IconName[IconName["Group"] = 327] = "Group";
    IconName[IconName["GroupedAscending"] = 328] = "GroupedAscending";
    IconName[IconName["GroupedDescending"] = 329] = "GroupedDescending";
    IconName[IconName["GroupedList"] = 330] = "GroupedList";
    IconName[IconName["HailDay"] = 331] = "HailDay";
    IconName[IconName["HailNight"] = 332] = "HailNight";
    IconName[IconName["Handwriting"] = 333] = "Handwriting";
    IconName[IconName["Header1"] = 334] = "Header1";
    IconName[IconName["Header2"] = 335] = "Header2";
    IconName[IconName["Header3"] = 336] = "Header3";
    IconName[IconName["Header4"] = 337] = "Header4";
    IconName[IconName["Headset"] = 338] = "Headset";
    IconName[IconName["Health"] = 339] = "Health";
    IconName[IconName["Heart"] = 340] = "Heart";
    IconName[IconName["HeartFill"] = 341] = "HeartFill";
    IconName[IconName["Help"] = 342] = "Help";
    IconName[IconName["HelpMirrored"] = 343] = "HelpMirrored";
    IconName[IconName["Hide"] = 344] = "Hide";
    IconName[IconName["Hide2"] = 345] = "Hide2";
    IconName[IconName["History"] = 346] = "History";
    IconName[IconName["Home"] = 347] = "Home";
    IconName[IconName["HomeSolid"] = 348] = "HomeSolid";
    IconName[IconName["Hospital"] = 349] = "Hospital";
    IconName[IconName["Hotel"] = 350] = "Hotel";
    IconName[IconName["Important"] = 351] = "Important";
    IconName[IconName["InboxCheck"] = 352] = "InboxCheck";
    IconName[IconName["IncidentTriangle"] = 353] = "IncidentTriangle";
    IconName[IconName["IncreaseIndentLegacy"] = 354] = "IncreaseIndentLegacy";
    IconName[IconName["Info"] = 355] = "Info";
    IconName[IconName["Info2"] = 356] = "Info2";
    IconName[IconName["InsertTextBox"] = 357] = "InsertTextBox";
    IconName[IconName["InternetSharing"] = 358] = "InternetSharing";
    IconName[IconName["iOSAppStoreLogo"] = 359] = "iOSAppStoreLogo";
    IconName[IconName["IssueTracking"] = 360] = "IssueTracking";
    IconName[IconName["IssueTrackingMirrored"] = 361] = "IssueTrackingMirrored";
    IconName[IconName["Italic"] = 362] = "Italic";
    IconName[IconName["JoinOnlineMeeting"] = 363] = "JoinOnlineMeeting";
    IconName[IconName["JS"] = 364] = "JS";
    IconName[IconName["Label"] = 365] = "Label";
    IconName[IconName["LandscapeOrientation"] = 366] = "LandscapeOrientation";
    IconName[IconName["LaptopSelected"] = 367] = "LaptopSelected";
    IconName[IconName["LargeGrid"] = 368] = "LargeGrid";
    IconName[IconName["Library"] = 369] = "Library";
    IconName[IconName["Lifesaver"] = 370] = "Lifesaver";
    IconName[IconName["LifesaverLock"] = 371] = "LifesaverLock";
    IconName[IconName["Light"] = 372] = "Light";
    IconName[IconName["Lightbulb"] = 373] = "Lightbulb";
    IconName[IconName["LightningBolt"] = 374] = "LightningBolt";
    IconName[IconName["Like"] = 375] = "Like";
    IconName[IconName["Link"] = 376] = "Link";
    IconName[IconName["List"] = 377] = "List";
    IconName[IconName["ListMirrored"] = 378] = "ListMirrored";
    IconName[IconName["Location"] = 379] = "Location";
    IconName[IconName["LocationCircle"] = 380] = "LocationCircle";
    IconName[IconName["LocationDot"] = 381] = "LocationDot";
    IconName[IconName["LocationFill"] = 382] = "LocationFill";
    IconName[IconName["Lock"] = 383] = "Lock";
    IconName[IconName["LowerBrightness"] = 384] = "LowerBrightness";
    IconName[IconName["LyncLogo"] = 385] = "LyncLogo";
    IconName[IconName["Mail"] = 386] = "Mail";
    IconName[IconName["MailAlert"] = 387] = "MailAlert";
    IconName[IconName["MailCheck"] = 388] = "MailCheck";
    IconName[IconName["MailFill"] = 389] = "MailFill";
    IconName[IconName["MailForward"] = 390] = "MailForward";
    IconName[IconName["MailForwardMirrored"] = 391] = "MailForwardMirrored";
    IconName[IconName["MailLowImportance"] = 392] = "MailLowImportance";
    IconName[IconName["MailPause"] = 393] = "MailPause";
    IconName[IconName["MailRepeat"] = 394] = "MailRepeat";
    IconName[IconName["MailReply"] = 395] = "MailReply";
    IconName[IconName["MailReplyAll"] = 396] = "MailReplyAll";
    IconName[IconName["MailReplyAllMirrored"] = 397] = "MailReplyAllMirrored";
    IconName[IconName["MailReplyMirrored"] = 398] = "MailReplyMirrored";
    IconName[IconName["MapDirections"] = 399] = "MapDirections";
    IconName[IconName["MapPin"] = 400] = "MapPin";
    IconName[IconName["Market"] = 401] = "Market";
    IconName[IconName["MarketDown"] = 402] = "MarketDown";
    IconName[IconName["Megaphone"] = 403] = "Megaphone";
    IconName[IconName["Memo"] = 404] = "Memo";
    IconName[IconName["Merge"] = 405] = "Merge";
    IconName[IconName["Message"] = 406] = "Message";
    IconName[IconName["MessageFill"] = 407] = "MessageFill";
    IconName[IconName["Microphone"] = 408] = "Microphone";
    IconName[IconName["MicrosoftStaffhubLogo"] = 409] = "MicrosoftStaffhubLogo";
    IconName[IconName["MiniLink"] = 410] = "MiniLink";
    IconName[IconName["MobileSelected"] = 411] = "MobileSelected";
    IconName[IconName["Money"] = 412] = "Money";
    IconName[IconName["More"] = 413] = "More";
    IconName[IconName["MoreSports"] = 414] = "MoreSports";
    IconName[IconName["Move"] = 415] = "Move";
    IconName[IconName["MoveToFolder"] = 416] = "MoveToFolder";
    IconName[IconName["MSNLogo"] = 417] = "MSNLogo";
    IconName[IconName["MultiSelect"] = 418] = "MultiSelect";
    IconName[IconName["MultiSelectMirrored"] = 419] = "MultiSelectMirrored";
    IconName[IconName["MusicInCollection"] = 420] = "MusicInCollection";
    IconName[IconName["MusicInCollectionFill"] = 421] = "MusicInCollectionFill";
    IconName[IconName["MusicNote"] = 422] = "MusicNote";
    IconName[IconName["Nav2DMapView"] = 423] = "Nav2DMapView";
    IconName[IconName["NewFolder"] = 424] = "NewFolder";
    IconName[IconName["News"] = 425] = "News";
    IconName[IconName["None"] = 426] = "None";
    IconName[IconName["NoteForward"] = 427] = "NoteForward";
    IconName[IconName["NotePinned"] = 428] = "NotePinned";
    IconName[IconName["NoteReply"] = 429] = "NoteReply";
    IconName[IconName["NumberedList"] = 430] = "NumberedList";
    IconName[IconName["NumberField"] = 431] = "NumberField";
    IconName[IconName["OfficeAssistantLogo"] = 432] = "OfficeAssistantLogo";
    IconName[IconName["OfficeFormLogo"] = 433] = "OfficeFormLogo";
    IconName[IconName["OfficeLogo"] = 434] = "OfficeLogo";
    IconName[IconName["OfficeStoreLogo"] = 435] = "OfficeStoreLogo";
    IconName[IconName["OfficeVideoLogo"] = 436] = "OfficeVideoLogo";
    IconName[IconName["OfflineOneDriveParachute"] = 437] = "OfflineOneDriveParachute";
    IconName[IconName["OfflineOneDriveParachuteDisabled"] = 438] = "OfflineOneDriveParachuteDisabled";
    IconName[IconName["OneDrive"] = 439] = "OneDrive";
    IconName[IconName["OneDriveAdd"] = 440] = "OneDriveAdd";
    IconName[IconName["OneNoteEduLogo"] = 441] = "OneNoteEduLogo";
    IconName[IconName["OneNoteLogo"] = 442] = "OneNoteLogo";
    IconName[IconName["OpenFile"] = 443] = "OpenFile";
    IconName[IconName["OpenFolderHorizontal"] = 444] = "OpenFolderHorizontal";
    IconName[IconName["OpenInNewWindow"] = 445] = "OpenInNewWindow";
    IconName[IconName["OpenPane"] = 446] = "OpenPane";
    IconName[IconName["OpenPaneMirrored"] = 447] = "OpenPaneMirrored";
    IconName[IconName["Org"] = 448] = "Org";
    IconName[IconName["OutlookLogo"] = 449] = "OutlookLogo";
    IconName[IconName["OutOfOffice"] = 450] = "OutOfOffice";
    IconName[IconName["Package"] = 451] = "Package";
    IconName[IconName["Page"] = 452] = "Page";
    IconName[IconName["PageAdd"] = 453] = "PageAdd";
    IconName[IconName["PageCheckedin"] = 454] = "PageCheckedin";
    IconName[IconName["PageCheckedOut"] = 455] = "PageCheckedOut";
    IconName[IconName["PageLeft"] = 456] = "PageLeft";
    IconName[IconName["PageRight"] = 457] = "PageRight";
    IconName[IconName["PageSolid"] = 458] = "PageSolid";
    IconName[IconName["PanoIndicator"] = 459] = "PanoIndicator";
    IconName[IconName["ParatureLogo"] = 460] = "ParatureLogo";
    IconName[IconName["PartlyCloudyDay"] = 461] = "PartlyCloudyDay";
    IconName[IconName["PartlyCloudyNight"] = 462] = "PartlyCloudyNight";
    IconName[IconName["PartyLeader"] = 463] = "PartyLeader";
    IconName[IconName["Pause"] = 464] = "Pause";
    IconName[IconName["PaymentCard"] = 465] = "PaymentCard";
    IconName[IconName["PC1"] = 466] = "PC1";
    IconName[IconName["PDF"] = 467] = "PDF";
    IconName[IconName["PencilReply"] = 468] = "PencilReply";
    IconName[IconName["People"] = 469] = "People";
    IconName[IconName["PeopleAdd"] = 470] = "PeopleAdd";
    IconName[IconName["PeopleAlert"] = 471] = "PeopleAlert";
    IconName[IconName["PeopleBlock"] = 472] = "PeopleBlock";
    IconName[IconName["PeoplePause"] = 473] = "PeoplePause";
    IconName[IconName["PeopleRepeat"] = 474] = "PeopleRepeat";
    IconName[IconName["Permissions"] = 475] = "Permissions";
    IconName[IconName["Phone"] = 476] = "Phone";
    IconName[IconName["Photo2"] = 477] = "Photo2";
    IconName[IconName["Photo2Add"] = 478] = "Photo2Add";
    IconName[IconName["Photo2Remove"] = 479] = "Photo2Remove";
    IconName[IconName["PhotoCollection"] = 480] = "PhotoCollection";
    IconName[IconName["Picture"] = 481] = "Picture";
    IconName[IconName["PictureLibrary"] = 482] = "PictureLibrary";
    IconName[IconName["PieDouble"] = 483] = "PieDouble";
    IconName[IconName["Pill"] = 484] = "Pill";
    IconName[IconName["Pin"] = 485] = "Pin";
    IconName[IconName["Pinned"] = 486] = "Pinned";
    IconName[IconName["PinnedFill"] = 487] = "PinnedFill";
    IconName[IconName["Planner"] = 488] = "Planner";
    IconName[IconName["Play"] = 489] = "Play";
    IconName[IconName["PlayerSettings"] = 490] = "PlayerSettings";
    IconName[IconName["POI"] = 491] = "POI";
    IconName[IconName["PostUpdate"] = 492] = "PostUpdate";
    IconName[IconName["PowerApps"] = 493] = "PowerApps";
    IconName[IconName["PowerApps2Logo"] = 494] = "PowerApps2Logo";
    IconName[IconName["PowerAppsLogo"] = 495] = "PowerAppsLogo";
    IconName[IconName["PowerBILogo"] = 496] = "PowerBILogo";
    IconName[IconName["PowerPointDocument"] = 497] = "PowerPointDocument";
    IconName[IconName["PowerPointLogo"] = 498] = "PowerPointLogo";
    IconName[IconName["Precipitation"] = 499] = "Precipitation";
    IconName[IconName["PresenceChickletVideo"] = 500] = "PresenceChickletVideo";
    IconName[IconName["Preview"] = 501] = "Preview";
    IconName[IconName["PreviewLink"] = 502] = "PreviewLink";
    IconName[IconName["Print"] = 503] = "Print";
    IconName[IconName["PrintfaxPrinterFile"] = 504] = "PrintfaxPrinterFile";
    IconName[IconName["Product"] = 505] = "Product";
    IconName[IconName["ProFootball"] = 506] = "ProFootball";
    IconName[IconName["ProHockey"] = 507] = "ProHockey";
    IconName[IconName["ProjectLogo"] = 508] = "ProjectLogo";
    IconName[IconName["ProtectedDocument"] = 509] = "ProtectedDocument";
    IconName[IconName["PublicCalendar"] = 510] = "PublicCalendar";
    IconName[IconName["PublicContactCard"] = 511] = "PublicContactCard";
    IconName[IconName["PublicEmail"] = 512] = "PublicEmail";
    IconName[IconName["PublicFolder"] = 513] = "PublicFolder";
    IconName[IconName["Puzzle"] = 514] = "Puzzle";
    IconName[IconName["Questionnaire"] = 515] = "Questionnaire";
    IconName[IconName["QuestionnaireMirrored"] = 516] = "QuestionnaireMirrored";
    IconName[IconName["QuickNote"] = 517] = "QuickNote";
    IconName[IconName["RadioBtnOn"] = 518] = "RadioBtnOn";
    IconName[IconName["RadioBullet"] = 519] = "RadioBullet";
    IconName[IconName["Rain"] = 520] = "Rain";
    IconName[IconName["RainShowersDay"] = 521] = "RainShowersDay";
    IconName[IconName["RainShowersNight"] = 522] = "RainShowersNight";
    IconName[IconName["RainSnow"] = 523] = "RainSnow";
    IconName[IconName["Read"] = 524] = "Read";
    IconName[IconName["ReadingMode"] = 525] = "ReadingMode";
    IconName[IconName["ReceiptCheck"] = 526] = "ReceiptCheck";
    IconName[IconName["ReceiptForward"] = 527] = "ReceiptForward";
    IconName[IconName["ReceiptReply"] = 528] = "ReceiptReply";
    IconName[IconName["Recent"] = 529] = "Recent";
    IconName[IconName["RecurringEvent"] = 530] = "RecurringEvent";
    IconName[IconName["RecurringTask"] = 531] = "RecurringTask";
    IconName[IconName["RecycleBin"] = 532] = "RecycleBin";
    IconName[IconName["RedEye"] = 533] = "RedEye";
    IconName[IconName["Redo"] = 534] = "Redo";
    IconName[IconName["Refresh"] = 535] = "Refresh";
    IconName[IconName["ReminderGroup"] = 536] = "ReminderGroup";
    IconName[IconName["Remove"] = 537] = "Remove";
    IconName[IconName["RemoveEvent"] = 538] = "RemoveEvent";
    IconName[IconName["RemoveFilter"] = 539] = "RemoveFilter";
    IconName[IconName["RemoveLink"] = 540] = "RemoveLink";
    IconName[IconName["RemoveOccurrence"] = 541] = "RemoveOccurrence";
    IconName[IconName["Rename"] = 542] = "Rename";
    IconName[IconName["ReopenPages"] = 543] = "ReopenPages";
    IconName[IconName["Repair"] = 544] = "Repair";
    IconName[IconName["Reply"] = 545] = "Reply";
    IconName[IconName["ReplyAll"] = 546] = "ReplyAll";
    IconName[IconName["ReplyAllAlt"] = 547] = "ReplyAllAlt";
    IconName[IconName["ReplyAllMirrored"] = 548] = "ReplyAllMirrored";
    IconName[IconName["ReplyAlt"] = 549] = "ReplyAlt";
    IconName[IconName["ReplyMirrored"] = 550] = "ReplyMirrored";
    IconName[IconName["ReportLibrary"] = 551] = "ReportLibrary";
    IconName[IconName["ReportLibraryMirrored"] = 552] = "ReportLibraryMirrored";
    IconName[IconName["ReturnToSession"] = 553] = "ReturnToSession";
    IconName[IconName["RevToggleKey"] = 554] = "RevToggleKey";
    IconName[IconName["Ribbon"] = 555] = "Ribbon";
    IconName[IconName["RightDoubleQuote"] = 556] = "RightDoubleQuote";
    IconName[IconName["Ringer"] = 557] = "Ringer";
    IconName[IconName["Room"] = 558] = "Room";
    IconName[IconName["Rotate"] = 559] = "Rotate";
    IconName[IconName["Rugby"] = 560] = "Rugby";
    IconName[IconName["Running"] = 561] = "Running";
    IconName[IconName["Sad"] = 562] = "Sad";
    IconName[IconName["Save"] = 563] = "Save";
    IconName[IconName["SaveAs"] = 564] = "SaveAs";
    IconName[IconName["Search"] = 565] = "Search";
    IconName[IconName["Section"] = 566] = "Section";
    IconName[IconName["Sections"] = 567] = "Sections";
    IconName[IconName["SecurityGroup"] = 568] = "SecurityGroup";
    IconName[IconName["Send"] = 569] = "Send";
    IconName[IconName["SendMirrored"] = 570] = "SendMirrored";
    IconName[IconName["SetAction"] = 571] = "SetAction";
    IconName[IconName["Settings"] = 572] = "Settings";
    IconName[IconName["Share"] = 573] = "Share";
    IconName[IconName["ShareiOS"] = 574] = "ShareiOS";
    IconName[IconName["SharepointLogo"] = 575] = "SharepointLogo";
    IconName[IconName["Shield"] = 576] = "Shield";
    IconName[IconName["Shop"] = 577] = "Shop";
    IconName[IconName["ShoppingCart"] = 578] = "ShoppingCart";
    IconName[IconName["ShowResults"] = 579] = "ShowResults";
    IconName[IconName["ShowResultsMirrored"] = 580] = "ShowResultsMirrored";
    IconName[IconName["SidePanel"] = 581] = "SidePanel";
    IconName[IconName["SingleBookmark"] = 582] = "SingleBookmark";
    IconName[IconName["SIPMove"] = 583] = "SIPMove";
    IconName[IconName["SkypeCheck"] = 584] = "SkypeCheck";
    IconName[IconName["SkypeCircleCheck"] = 585] = "SkypeCircleCheck";
    IconName[IconName["SkypeCircleClock"] = 586] = "SkypeCircleClock";
    IconName[IconName["SkypeCircleMinus"] = 587] = "SkypeCircleMinus";
    IconName[IconName["SkypeClock"] = 588] = "SkypeClock";
    IconName[IconName["SkypeLogo"] = 589] = "SkypeLogo";
    IconName[IconName["SkypeMessage"] = 590] = "SkypeMessage";
    IconName[IconName["SkypeMinus"] = 591] = "SkypeMinus";
    IconName[IconName["SliderThumb"] = 592] = "SliderThumb";
    IconName[IconName["Snow"] = 593] = "Snow";
    IconName[IconName["SnowShowerDay"] = 594] = "SnowShowerDay";
    IconName[IconName["SnowShowerNight"] = 595] = "SnowShowerNight";
    IconName[IconName["Soccer"] = 596] = "Soccer";
    IconName[IconName["SocialListeningLogo"] = 597] = "SocialListeningLogo";
    IconName[IconName["Sort"] = 598] = "Sort";
    IconName[IconName["SortDown"] = 599] = "SortDown";
    IconName[IconName["SortLines"] = 600] = "SortLines";
    IconName[IconName["SortUp"] = 601] = "SortUp";
    IconName[IconName["Speakers"] = 602] = "Speakers";
    IconName[IconName["SpeedHigh"] = 603] = "SpeedHigh";
    IconName[IconName["Split"] = 604] = "Split";
    IconName[IconName["Squalls"] = 605] = "Squalls";
    IconName[IconName["StackIndicator"] = 606] = "StackIndicator";
    IconName[IconName["Starburst"] = 607] = "Starburst";
    IconName[IconName["StatusErrorFull"] = 608] = "StatusErrorFull";
    IconName[IconName["StatusTriangle"] = 609] = "StatusTriangle";
    IconName[IconName["StockDown"] = 610] = "StockDown";
    IconName[IconName["StockUp"] = 611] = "StockUp";
    IconName[IconName["Stopwatch"] = 612] = "Stopwatch";
    IconName[IconName["StoreLogo"] = 613] = "StoreLogo";
    IconName[IconName["StoreLogoMed"] = 614] = "StoreLogoMed";
    IconName[IconName["Strikethrough"] = 615] = "Strikethrough";
    IconName[IconName["Subscribe"] = 616] = "Subscribe";
    IconName[IconName["Subscript"] = 617] = "Subscript";
    IconName[IconName["Suitcase"] = 618] = "Suitcase";
    IconName[IconName["SunAdd"] = 619] = "SunAdd";
    IconName[IconName["Sunny"] = 620] = "Sunny";
    IconName[IconName["SunQuestionMark"] = 621] = "SunQuestionMark";
    IconName[IconName["Superscript"] = 622] = "Superscript";
    IconName[IconName["SwayLogo"] = 623] = "SwayLogo";
    IconName[IconName["Switch"] = 624] = "Switch";
    IconName[IconName["SwitcherStartEnd"] = 625] = "SwitcherStartEnd";
    IconName[IconName["Sync"] = 626] = "Sync";
    IconName[IconName["SyncFolder"] = 627] = "SyncFolder";
    IconName[IconName["SyncToPC"] = 628] = "SyncToPC";
    IconName[IconName["System"] = 629] = "System";
    IconName[IconName["Tab"] = 630] = "Tab";
    IconName[IconName["Table"] = 631] = "Table";
    IconName[IconName["Tablet"] = 632] = "Tablet";
    IconName[IconName["TabletSelected"] = 633] = "TabletSelected";
    IconName[IconName["Tag"] = 634] = "Tag";
    IconName[IconName["TaskManager"] = 635] = "TaskManager";
    IconName[IconName["TaskManagerMirrored"] = 636] = "TaskManagerMirrored";
    IconName[IconName["Teamwork"] = 637] = "Teamwork";
    IconName[IconName["TemporaryUser"] = 638] = "TemporaryUser";
    IconName[IconName["Tennis"] = 639] = "Tennis";
    IconName[IconName["TextBox"] = 640] = "TextBox";
    IconName[IconName["TextField"] = 641] = "TextField";
    IconName[IconName["ThumbnailView"] = 642] = "ThumbnailView";
    IconName[IconName["ThumbnailViewMirrored"] = 643] = "ThumbnailViewMirrored";
    IconName[IconName["Thunderstorms"] = 644] = "Thunderstorms";
    IconName[IconName["Ticket"] = 645] = "Ticket";
    IconName[IconName["Tiles"] = 646] = "Tiles";
    IconName[IconName["Tiles2"] = 647] = "Tiles2";
    IconName[IconName["Timeline"] = 648] = "Timeline";
    IconName[IconName["Timer"] = 649] = "Timer";
    IconName[IconName["ToggleBorder"] = 650] = "ToggleBorder";
    IconName[IconName["ToggleFilled"] = 651] = "ToggleFilled";
    IconName[IconName["ToggleThumb"] = 652] = "ToggleThumb";
    IconName[IconName["Touch"] = 653] = "Touch";
    IconName[IconName["TouchPointer"] = 654] = "TouchPointer";
    IconName[IconName["Train"] = 655] = "Train";
    IconName[IconName["TrainSolid"] = 656] = "TrainSolid";
    IconName[IconName["TransferCall"] = 657] = "TransferCall";
    IconName[IconName["TriangleDown12"] = 658] = "TriangleDown12";
    IconName[IconName["TriangleLeft12"] = 659] = "TriangleLeft12";
    IconName[IconName["TriangleRight12"] = 660] = "TriangleRight12";
    IconName[IconName["TriangleSolidDown12"] = 661] = "TriangleSolidDown12";
    IconName[IconName["TriangleSolidLeft12"] = 662] = "TriangleSolidLeft12";
    IconName[IconName["TriangleSolidRight12"] = 663] = "TriangleSolidRight12";
    IconName[IconName["TriangleSolidUp12"] = 664] = "TriangleSolidUp12";
    IconName[IconName["TriangleUp12"] = 665] = "TriangleUp12";
    IconName[IconName["Trophy"] = 666] = "Trophy";
    IconName[IconName["TurnRight"] = 667] = "TurnRight";
    IconName[IconName["TVMonitor"] = 668] = "TVMonitor";
    IconName[IconName["TVMonitorSelected"] = 669] = "TVMonitorSelected";
    IconName[IconName["Underline"] = 670] = "Underline";
    IconName[IconName["Undo"] = 671] = "Undo";
    IconName[IconName["Unfavorite"] = 672] = "Unfavorite";
    IconName[IconName["UnknownCall"] = 673] = "UnknownCall";
    IconName[IconName["Unlock"] = 674] = "Unlock";
    IconName[IconName["Unpin"] = 675] = "Unpin";
    IconName[IconName["Unsubscribe"] = 676] = "Unsubscribe";
    IconName[IconName["UnsyncFolder"] = 677] = "UnsyncFolder";
    IconName[IconName["Up"] = 678] = "Up";
    IconName[IconName["Upload"] = 679] = "Upload";
    IconName[IconName["Video"] = 680] = "Video";
    IconName[IconName["VideoSolid"] = 681] = "VideoSolid";
    IconName[IconName["View"] = 682] = "View";
    IconName[IconName["ViewAll"] = 683] = "ViewAll";
    IconName[IconName["ViewAll2"] = 684] = "ViewAll2";
    IconName[IconName["VisioLogo"] = 685] = "VisioLogo";
    IconName[IconName["VoicemailForward"] = 686] = "VoicemailForward";
    IconName[IconName["VoicemailReply"] = 687] = "VoicemailReply";
    IconName[IconName["Volume0"] = 688] = "Volume0";
    IconName[IconName["Volume1"] = 689] = "Volume1";
    IconName[IconName["Volume2"] = 690] = "Volume2";
    IconName[IconName["Volume3"] = 691] = "Volume3";
    IconName[IconName["VolumeDisabled"] = 692] = "VolumeDisabled";
    IconName[IconName["Waffle"] = 693] = "Waffle";
    IconName[IconName["Warning"] = 694] = "Warning";
    IconName[IconName["Website"] = 695] = "Website";
    IconName[IconName["Weights"] = 696] = "Weights";
    IconName[IconName["WindDirection"] = 697] = "WindDirection";
    IconName[IconName["WindowsLogo"] = 698] = "WindowsLogo";
    IconName[IconName["WipePhone"] = 699] = "WipePhone";
    IconName[IconName["WordDocument"] = 700] = "WordDocument";
    IconName[IconName["WordLogo"] = 701] = "WordLogo";
    IconName[IconName["Work"] = 702] = "Work";
    IconName[IconName["WorkFlow"] = 703] = "WorkFlow";
    IconName[IconName["WorldClock"] = 704] = "WorldClock";
    IconName[IconName["YammerLogo"] = 705] = "YammerLogo";
    IconName[IconName["Zoom"] = 706] = "Zoom";
    IconName[IconName["ZoomIn"] = 707] = "ZoomIn";
    IconName[IconName["ZoomOut"] = 708] = "ZoomOut";
})(IconName = exports.IconName || (exports.IconName = {}));

//# sourceMappingURL=IconName.js.map



//////////////////
// WEBPACK FOOTER
// ../components/Icon/IconName.js
// module id = 54
// module chunks = 0